import { validateRequired } from '../../../store/actions/ui/formUtils/validators';

const checkRequired = (value, msg = '') => {
  const error = validateRequired(msg)(value).required;
  return error ? [error] : [];
};

export default checkRequired;
